import React from "react";

function CardSkeleton() {
  return <div className="loading-custom custom-card"></div>;
}

export default CardSkeleton;
